import 'bootstrap';

import './template-modules/plyr';
import './template-modules/tooltip';
import './template-modules/countdown'
import './template-modules/headroom';
import './template-modules/tiny-slider';
import './template-modules/prism';
import './template-modules/aos';
import './template-modules/navbar';
import './template-modules/parallax';
import './template-modules/big-picture';
import './template-modules/isotope';
import './template-modules/offcanvas';
import './template-modules/forms';
import './template-modules/nouislider';
import './template-modules/counter';
import './template-modules/typed';
import './template-modules/smooth-scroll';

const scrollTopButtons = [...document.querySelectorAll('.scroll-top')];
const form = document.querySelector('form');
const successModalBtn = document.querySelector('[data-bs-target="#success-modal"]');
const errorModalBtn = document.querySelector('[data-bs-target="#error-modal"]');
const inputs = [...document.querySelectorAll('input')];
const textAreas = [...document.querySelectorAll('textarea')];
const setCookiesBtn = document.querySelector('#setCookiesBtn')

const cookieRendered = new CookieRenderer()

setCookiesBtn?.addEventListener('click', (event) => {
    event.preventDefault()

    cookieRendered.render()
})

scrollTopButtons.forEach((button) => {
    button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
})

form?.addEventListener('submit', async (event) => {
    event.preventDefault();

    const requestPath = event.target.getAttribute('action')

    const formData = new FormData();
    const fields = [];

    if (inputs.length > 0) {
        fields.push(...inputs)
    }

    if (textAreas.length > 0) {
        fields.push(...textAreas)
    }

    fields.forEach((formElement) => {
        if (formElement.type === 'file') {
            const file = formElement.files[0];
            formData.append(formElement.name, file);
        } else if (formElement.type === 'checkbox') {
            formData.append(formElement.name, formElement.checked);
        } else {
            formData.append(formElement.name, formElement.value);
        }
    })

    try {
        const response = await fetch(requestPath, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })

        if (!response.ok) {
            throw new Error()
        }

        successModalBtn.click();

        clearForm(form)
    } catch (e) {
        errorModalBtn.click();
    }
});

const clearForm = (form) => {
    const formElements = form.elements;

    for (let i = 0; i < formElements.length; i++) {
        const element = formElements[i];
        if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
            if (element.type === 'checkbox') {
                element.checked = false;
            } else {
                element.value = '';
            }
        }
    }
};

class CookieRenderer {
    selectableCookies = ['statistical', 'marketing']

    constructor() {
        this.cookiesPopup = document.querySelector('#cookiesPopup')
        this.staticConsentInput = document.querySelector('input[data-type="statistical"]')
        this.marketingConsentInput = document.querySelector('input[data-type="marketing"]')
        this.chooseCookiesBtn = document.querySelector('.cookies-btn--outline')
        this.acceptAllBtn = document.querySelector('.cookies-btn--contained')

        if (!this.cookiesPopup) {
            return
        }

        this.chooseCookiesBtn.addEventListener('click', this.toggleCookiesContent)
        this.acceptAllBtn.addEventListener('click', this.acceptAll)
        this.staticConsentInput.addEventListener('change', () => this.toggleConsent('statistical'))
        this.marketingConsentInput.addEventListener('change', () => this.toggleConsent('marketing'))
    }


    render = () => {
        this.selectedCookies = []

        if (!this.cookiesPopup) {
            return
        }

        const dataFromLocalStorage = JSON.parse(localStorage.getItem('consentMode'))

        if (dataFromLocalStorage) {
            if (dataFromLocalStorage.ad_storage === 'granted') {
                if (!this.selectedCookies.includes('marketing')) {
                    this.selectedCookies.push('marketing')
                }
                this.marketingConsentInput.checked = true
            }
            if (dataFromLocalStorage.analytics_storage === 'granted') {
                if (!this.selectedCookies.includes('statistical')) {
                    this.selectedCookies.push('statistical')
                }
                this.staticConsentInput.checked = true
            }
        }

        if (this.chooseCookiesBtn.textContent.toLowerCase() !== 'akceptuj wybrane') {
            this.showFirstStage()
        }


        this.cookiesPopup.classList.remove('cookies-popup--hidden')
    }

    toggleCookiesContent = () => {
        const cookiesContentElements = [...document.querySelectorAll('.cookies-popup__content')]

        cookiesContentElements.forEach((element) => {
            element.classList.toggle('cookies-popup__content--hidden')
        })
        this.chooseCookiesBtn.textContent = this.selectedCookies.length ? 'Akceptuj wybór' : 'Odrzuć wszystkie'
        this.chooseCookiesBtn.removeEventListener('click', this.toggleCookiesContent)
        this.chooseCookiesBtn.addEventListener('click', this.acceptSelected)
    }

    showFirstStage = () => {
        const cookiesContentElements = [...document.querySelectorAll('.cookies-popup__content')]

        cookiesContentElements.forEach((element) => {
            element.classList.toggle('cookies-popup__content--hidden')
        })

        this.chooseCookiesBtn.textContent = 'Akceptuj wybrane'
        this.chooseCookiesBtn.addEventListener('click', this.toggleCookiesContent)
        this.chooseCookiesBtn.removeEventListener('click', this.acceptSelected)
    }

    toggleConsent = (consentType) => {
        if (this.selectedCookies.includes(consentType)) {
            this.selectedCookies = this.selectedCookies.filter(selectedConsent => selectedConsent !== consentType)
        } else {
            this.selectedCookies.push(consentType)
        }

        if (this.selectedCookies.length) {
            this.chooseCookiesBtn.textContent = 'Akceptuj wybór'
        } else {
            this.chooseCookiesBtn.textContent = 'Odrzuć wszystkie'
        }
    }

    acceptSelected = () => {
        this.saveToStorage(false)
    }

    acceptAll = () => {
        this.saveToStorage(true)
    }

    saveToStorage = (acceptAll) => {
        const gtagConsentMode = {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied',
            'personalization_storage': 'denied',
            'functionality_storage': 'denied',
            'security_storage': 'denied',
        }

        if (acceptAll) {
            Object.assign(this.selectedCookies, this.selectableCookies)
        }

        if (this.selectedCookies.length) {
            gtagConsentMode['ad_storage'] = this.selectedCookies.indexOf('marketing') > -1 ? 'granted' : 'denied'
            gtagConsentMode['ad_user_data'] = this.selectedCookies.indexOf('marketing') > -1 ? 'granted' : 'denied'
            gtagConsentMode['ad_personalization'] = this.selectedCookies.indexOf('marketing') > -1 ? 'granted' : 'denied'
            gtagConsentMode['analytics_storage'] = this.selectedCookies.indexOf('statistical') > -1 ? 'granted' : 'denied'
        }

        localStorage.setItem('consentMode', JSON.stringify(gtagConsentMode))
        window.gtag('consent', 'update', gtagConsentMode)

        this.cookiesPopup.classList.add('cookies-popup--hidden')
    }
}

if (!localStorage.getItem('consentMode')) {
    cookieRendered.render()
}
